export const BaseUrl = "https://api.nativesutra.com/";

export const accessToken = localStorage.getItem("accessTokenNative");
